import * as _ from 'lodash';

import { Util } from '@finley-technologies/finley-types';

import {
  LedgerTransactionGQLType,
  OrganizationGQLType,
  TAccountTypeGQLType,
} from 'types/dashboard-core-gqlTypes.generated';

import { truncateLiabilityAccountType } from 'packages/statements/ui/statementsUtils';

export interface LedgerTransactionWithAccountNameAndType
  extends LedgerTransactionGQLType {
  accountType: TAccountTypeGQLType;
  accountName: string;
  organizationName: string;
}
export type ExpensesFeesTransactions = Record<
  Util.FullDateStr,
  LedgerTransactionWithAccountNameAndType[]
>;

export const getLiabilityAccountTypeOptions = (
  accountTypes: TAccountTypeGQLType[],
) => {
  return _.map(accountTypes, (accountType) => {
    return {
      value: accountType,
      label: truncateLiabilityAccountType(accountType),
    };
  });
};

export const formatExpensesFeesTransactions = (
  organizations: Pick<OrganizationGQLType, 'id' | 'name'>[],
  transactions?: LedgerTransactionGQLType[],
): ExpensesFeesTransactions => {
  if (!transactions) {
    return {};
  }

  const descendingTransactions = _.reverse(_.clone(transactions));

  const descendingTransactionsWithName = _.map(
    descendingTransactions,
    (descendingTransaction) => {
      const { accountType, organizationId } = descendingTransaction;
      const accountName = truncateLiabilityAccountType(accountType);
      return {
        ...descendingTransaction,
        accountType,
        accountName: accountName || accountType,
        organizationName:
          organizations.find(({ id }) => id === organizationId)?.name ??
          'Countersigner',
      };
    },
  );

  const transactionsByDate = _.groupBy(
    descendingTransactionsWithName,
    'postingDate',
  );

  return transactionsByDate;
};
